import { useContext } from 'react';

import { encryptionContext } from '@modules/core/contexts/encryption';
import { IEncryptionContext } from '@modules/core/contexts/encryption/interfaces';

const useEncryption = () => useContext<IEncryptionContext>(encryptionContext);

export default useEncryption;
